export const JOIN_FORM_URL = "https://forms.gle/gkeSHyo6t62cwuhz5";
